import { IGuideInfoData } from "./guide.types";

export class GuideInfo implements IGuideInfoData {
  readonly title: string;
  readonly content: string;

  constructor(data: IGuideInfoData) {
    this.title = data.title;
    this.content = data.content;
  }
}
